import { ActivatedRouteSnapshot, Routes } from '@angular/router';

import { canActivate, redirectNotClaimsTo } from 'anatoliapps-angular/auth';

const redirectUnauthorizedToSignIn = (route: ActivatedRouteSnapshot) => redirectNotClaimsTo(`/account/auth/signIn?continue=${route.url[0]?.path ?? '/'}`, 'isAdmin', 'isEditor');

export const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent) },
      { path: 'donate', loadChildren: () => import('./features/donate/donate.routes').then(m => m.donateRoutes) },
    ],
    ...canActivate(redirectUnauthorizedToSignIn)
  },
  { path: 'account', loadChildren: () => import('./features/account/account.routes').then(m => m.accountRoutes) }
];
